// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__aTVYN","panel":"Robot_panel__6IeJN","wrapper":"Robot_wrapper__7s1h+","info":"Robot_info__bfSmi","unit":"Robot_unit__M+oSP"};